<template src="./GroupPositions.html"></template>

<script>
import sitesTopMenu from "@/components/sites/components/topMenu"
import Pagination from "@/components/components/pagination"
import Chart from '@/components/brand/dynamics/components/Chart';
import {createNamespacedHelpers} from 'vuex'
import SelfDateRangePicker from "@/components/components/SelfDataRagePicker"

const {mapGetters, mapActions} = createNamespacedHelpers('sites/groupPositions')

export default {
  name: "GroupPositions",
  components: {
    sitesTopMenu,
    Pagination,
    Chart,
    SelfDateRangePicker,
  },
  data() {

    return {

      showBottomOverlay: false,
      showOverlay: false,
      searchVal: '',
      currentGroupId: this.$route.params.groupId,
      currentSearchEngine: 'yandex',
      currentRegionId: null,
      searchEngineList: [
        {value: 'yandex', text: 'Yandex'},
        {value: 'google', text: 'Google'},
      ],
      fields: [
        {
          key: 'brand.name',
          label: 'Бренд',
          sortable: true
        },
        {
          key: 'query',
          label: 'Запросы',
          sortable: true
        },
        {
          key: 'frequency',
          label: 'Общая частота',
          sortable: true
        },
      ],
      chartName: '',
      chartFrom: null,
      chartTo: null,
      activeQueryId: null,
      dateRange: {},
      prepareFields: [
        {
          key: 'brand.name',
          label: 'Бренд',
          sortable: true
        },
        {
          key: 'query',
          label: 'Запросы',
          sortable: true
        },
      ],
      lastScrollCheck: false,
      bottomOverlayLength: 0,
      scrollPosition: 0,

    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'GET_HISTORY',
      'GET_GROUPS',
      'GET_REGIONS',
    ]),
    partLoadData: function () {
      if (
          !this.isBottomScroll()
          || this.currentGroupId == null
          || this.showBottomOverlay > 0
          || this.lastScrollCheck
          || this.HAVE_EMPTY_RESPONSE
      ) {
        this.lastScrollCheck = false
        return
      }
      this.lastScrollCheck = true
      this.GET_REGIONS({th: this})
    },
    isBottomScroll: function () {
      let rect = this.$refs.bottomOverlay.getBoundingClientRect()

      if (
          (window.innerHeight - rect.bottom) >= 0
          && (this.bottomOverlayLength - rect.bottom) > 0
      ) {
        this.bottomOverlayLength = rect.bottom
        // save scroll position
        this.savePosition()

        return true
      }
      this.bottomOverlayLength = rect.bottom

      return false
    },
    scrollTo: function () {
      if (this.$refs.queryList === undefined) {
        return
      }
      this.$nextTick(() => {
        window.scrollTo(0, this.scrollPosition)
      })
    },
    savePosition: function () {
      let rect = this.$refs.queryList.$el.getBoundingClientRect()
      this.scrollPosition = rect.height - window.innerHeight + 208
    },


    groupFilterProcessing: function () {
      // clear
      this.valueResetMin()
      this.GET_REGIONS({th: this})
    },
    prepareName: function (name) {
      name = name.replace(' ', '&nbsp;');
      return name
    },
    search: function () {
      this.$store.commit('sites/groupPositions/SEARCH_VALUE', this.searchVal)
      // clear
      this.valueResetMin()
      this.GET_REGIONS({th: this})
    },
    reset: function () {
      this.searchVal = ''
      this.search()
    },
    sortingChanged: function (ctx) {
      this.$store.commit('sites/groupPositions/SORT_FIELD', ctx.sortBy)
      this.$store.commit('sites/groupPositions/SORT_DIR', ctx.sortDesc ? 'desc' : 'asc')
      // clear
      this.valueResetMin()
      // get new data
      this.GET_REGIONS({th: this})
    },
    regionChange: function () {
      this.valueResetMin()
      // this.chartName = ''
      this.$store.commit('sites/groupPositions/CURRENT_REGION_ID', this.currentRegionId);
      this.$store.commit('sites/groupPositions/HISTORY_DATA', {});
      this.$store.commit('sites/groupPositions/CURRENT_PAGE', 1)
      this.GET_DATA({th: this})
    },
    selectQuery: function (queryId, query) {
      this.activeQueryId = queryId
      this.chartName = query
      this.getChartDat()
    },
    getChartDat: function () {
      if (this.chartFrom != null && this.chartTo != null && this.activeQueryId != null) {
        this.GET_HISTORY({th: this, id: this.activeQueryId, from: this.chartFrom, to: this.chartTo});
      }
    },
    updateChart: function (val) {
      this.chartFrom = val.from
      this.chartTo = val.to
      this.getChartDat()
    },
    prepareTableField: function () {
      // copy fields
      this.prepareFields = this.fields.slice()
      // processing
      for (let key in this.FIELD_HEADER) {
        let parts = key.split('_');
        this.prepareFields.push({
          key: key,
          label: parts[1].padStart(2, "0") + '.' + parts[0],
          sortable: false
        })
      }
    },
    sortPositionData: function (data) {
      // check if data is empty
      if (data == null || data.length == 0) {
        return data
      }
      // sort
      let sorted = []
      // push only isBasic=true
      for (let key in data) {
        if (data[key].isBasic == true) {
          sorted.push(data[key])
        }
      }
      //push empty if sorted not empty
      if (sorted.length > 0) {
        let emptyRow = {}
        for (let key in data[0]) {
          emptyRow[key] = 'empty'
        }
        sorted.push(emptyRow)
      }
      // push only isBasic!=true
      for (let key in data) {
        if (data[key].isBasic != true) {
          sorted.push(data[key])
        }
      }

      return sorted
    },
    groupPositionData: function (data) {
      // check if data is empty
      if (data.length == 0 || data[0] == null) {
        return data
      }
      let result = []
      for (let key in this.SITE_LIST) {
        let siteId = this.SITE_LIST[key].id
        let groupSite = []
        for (let key2 in data) {
          if (data[key2].site.id == siteId) {
            groupSite.push(data[key2])
          }
        }
        if (groupSite.length > 0) {
          // sort
          groupSite = this.sortPositionData(groupSite)
          // set site row2
          let emptySiteRow = {}
          for (let nameKey in data[0]) {
            emptySiteRow[nameKey] = 'empty'
          }
          // empty row
          result.push(emptySiteRow)
          let siteRow = Object.assign({}, emptySiteRow)
          siteRow.brand = {
            'name': this.SITE_LIST[key].domain,
            'saleId': 0
          }
          // row with site name
          result.push(siteRow)

          result = result.concat(groupSite)
        }
      }

      return result
    },
    valueReset: function () {
      this.$store.commit('sites/groupPositions/CURRENT_REGION_ID', null);
      this.$store.commit('sites/groupPositions/REGION_LIST', []);
      this.$store.commit('sites/groupPositions/CURRENT_REGION_DATA', {});
      this.$store.commit('sites/groupPositions/HISTORY_DATA', {});
      this.$store.commit('sites/groupPositions/CURRENT_PAGE', 1)
      this.$store.commit('sites/groupPositions/RAW_POSITIONS_DATA', [])
      this.$store.commit('sites/groupPositions/HAVE_EMPTY_RESPONSE', false);
      this.$store.commit('sites/groupPositions/PER_PAGE', 60);
      this.showBottomOverlay = false
      this.showOverlay = false
    },
    valueResetMin: function () {
      this.$store.commit('sites/groupPositions/HISTORY_DATA', {});
      this.$store.commit('sites/groupPositions/CURRENT_PAGE', 1)
      this.$store.commit('sites/groupPositions/RAW_POSITIONS_DATA', [])
      this.$store.commit('sites/groupPositions/HAVE_EMPTY_RESPONSE', false);
      this.$store.commit('sites/groupPositions/PER_PAGE', 60);
      this.showBottomOverlay = false
      this.showOverlay = false
    }
  },
  computed: {
    ...mapGetters([
      'POSITIONS_DATA',
      'CURRENT_PAGE',
      'AMOUNT_PAGE',
      'TOTAL_ROWS',
      'SITE_LIST',
      'REGION_LIST',
      'PER_PAGE',
      'SEARCH_VALUE',
      'CURRENT_REGION_DATA',
      'SORT_DIR',
      'SORT_FIELD',
      'HISTORY_DATA',
      'CURRENT_SITE_ID',
      'GROUPS',
      'CURRENT_GROUP_ID',
      'HAVE_EMPTY_RESPONSE',
      'FIELD_HEADER',
    ]),
    getGroupFilterOptions: function () {
      let groupOptions = []
      for (let key in this.GROUPS) {
        let val = this.GROUPS[key]
        groupOptions.push({value: val.id, text: val.name})
      }

      return groupOptions
    }
  },
  watch: {
    currentSearchEngine(newVal) {
      if (newVal == undefined) {
        return
      }
      // this.chartName = ''
      this.$store.commit('sites/groupPositions/CURRENT_SEARCH_ENGINE', newVal);
      this.valueReset()
      this.GET_REGIONS({th: this})
    },
    currentGroupId(newVal) {
      this.$store.commit('sites/groupPositions/CURRENT_GROUP_ID', newVal)
      this.valueReset()
      this.GET_REGIONS({th: this})
    }
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('sites') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }

    if (this.CURRENT_SEARCH_ENGINE !== undefined) {
      this.currentSearchEngine = this.CURRENT_SEARCH_ENGINE
    }
    if (this.POSITIONS_DATA.length == 0 || this.CURRENT_GROUP_ID != this.currentGroupId) {
      this.$store.commit('sites/groupPositions/CURRENT_GROUP_ID', this.currentGroupId)
    }
    if (this.REGION_LIST.length == 0) {
      this.GET_REGIONS({th: this})
    }
    if (this.CURRENT_REGION_ID != null) {
      this.currentRegionId = this.CURRENT_REGION_ID
    }
    this.$store.commit('sites/groupPositions/CURRENT_GROUP_ID', this.currentGroupId)
    if (this.GROUPS.length == 0) {
      this.GET_GROUPS({th: this})
    }
  },
  created() {
    window.addEventListener("scroll", this.partLoadData)
  },
  destroyed() {
    window.removeEventListener('scroll', this.partLoadData)
  },
}
</script>

<style scoped>
.search-box {
  width: 375px;
  float: left
}

.total-search-box {
  width: 525px;
}

.query-link {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
}

.query-link:hover {
  text-decoration: underline;
}

.chart-col {
  position: fixed;
  width: 500px;
  margin: auto;
}

.chart-box {
  width: 600px;
  display: block;
}

.back {
  text-align: left;
}
.site-group-list {
  /*min-height: 1057px;*/
  position: relative;
  margin-bottom: 50px;
}
.bottom-overlay {
  position: absolute;
  bottom: -43px;
  width: 100%;
  text-align: center;
  height: 44px;
  /*background: #ccc;*/
  padding-top: 25px;
  z-index: 100;
}
.sticky {
  position: sticky;
  top: 10px;
  z-index: 100;
}
.sticky-30 {
  position: sticky;
  top: 50px;
  z-index: 100;
}
</style>

<style>

</style>